<template>
<div class="edit-area" v-loading.fullscreen.lock="fullscreenLoading">
  <div class="container-base fullscreen">
    <h1>
      야기메일
    </h1>
    <div class="overflow-scroll-x step"
      ref="step">
      <ol>
        <li v-for="(item, index) in quickmailCards"
          :ref="'steps'"
          :key="item.id"
          :index="index"
          :class="{current:(item.id == currentCardId),
                     over:(index < currentCardIndex)}"
          v-ripple>
          <a href="#"
             @click="goCardTo(item.id);$event.preventDefault()">
            {{ item.title }}
          </a>
        </li>
      </ol>
    </div>
    <v-touch v-bind:enabled="{swipe:true, press:false, pan:false, tap:false, rotate:false, pinch:false}"
      v-on:swipeleft="swipeNextCard"
      v-on:swiperight="swipePrevCard"
      v-bind:swipe-options="{direction:'horizontal'}">
      <div class="cards"
        v-show="currentCardId">

        <component v-bind:is="buyform"
          ref="editFormat"
          :current-card-id="currentCardId"></component>

        <div class="card-pager-nav">
          <div class="pager">
            <el-button v-ripple
              v-if="currentCardId!='payment'"
              @click="goNextCard"
              :disabled="!isNextCardAvailable"
              type="primary">
              다음 <i class="el-icon-d-arrow-right"></i>
            </el-button>
            <el-button v-ripple
              v-else
              @click="paymentQuickEmail"
              :disabled="!isNextCardAvailable"
              type="primary">
              위내용으로 구입하기 <i class="el-icon-d-arrow-right"></i>
            </el-button>

            <el-button v-ripple
              v-if="currentCardId!='complete'"
              icon="el-icon-d-arrow-left"
              @click="goPrevCard"
              :type="isNextCardAvailable ? 'text': 'primary'"
              :disabled="!isPrevCardAvailable">
              이전
            </el-button>
          </div>
        </div>
      </div>
    </v-touch>
  </div>


</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<script>
import basicInfo from '@/components/BasicInfo'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
import QuickmailCards from '@/assets/formats/quickemail-cards'
import QuickmailBuy from '@/components/formats/QuickEmailBuy'
import LoginForms from '@/components/RenewLoginForms'
import firebase from 'firebase/app'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    cardId: {
      type: String
    }
  },
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      fullscreenLoading: false,
      buyform: QuickmailBuy,
      quickmailCards: QuickmailCards,
      formatData: {},
      formatInfo: {},
      basicData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      currentCardId: '',
      previewHtml: '',
      previewDialogVisible: true,
      previewScale: 1,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: false,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      currentFormat: {},
      downloadPdfEnabled: true,
      fontOptions: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      fontNames: [
        {
          value: "font-family: 'Noto Sans JP', sans-serif;",
          label: 'Noto Sans JP'
        },
        {
          value: "font-family: 'Noto Serif JP', serif;",
          label: 'Noto Serif JP'
        },
        {
          value: "font-family: 'Zen Maru Gothic', sans-serif;",
          label: 'yagish고딕'
        },
        {
          value: "font-family: 'BIZ UDPMincho', serif;",
          label: 'yagish명조'
        },
        {
          value: "font-family: 'DotGothic16', sans-serif;",
          label: '도트고딕16'
        },
        {
          value: "font-family: 'Kiwi Maru', serif;",
          label: 'Kiwi Maru'
        },
        {
          value: "font-family: 'Klee One', cursive;",
          label: 'Klee One'
        },
        {
          value: "font-family: 'Kosugi', sans-serif;",
          label: 'Kosugi'
        },
        {
          value: "font-family: 'Zen Kurenaido', sans-serif;",
          label: 'Zen Kurenaido'
        }
      ],
      pdfBlob: null
    }
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    previewDialogStyleObject: function () {
      if (this.previewDialogVisible) {
        return {
          visibility: 'visible',
          height: 'auto'
        }
      } else {
        return {
          visibility: 'hidden',
          overflow: 'hidden',
          height: 0
        }
      }
    },
    isDevelopment: function () {
      return process.env.NODE_ENV === 'development'
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    },
    firstCardId: function () {
      console.error(this.quickmailCards[0].id)
      return this.quickmailCards[0].id
    },
    isNextCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex + 1 < this.quickmailCards.length
    },
    isPrevCardAvailable: function () {
      if (!this.currentCardId) return
      return this.currentCardIndex > 0
    },
    currentCardIndex: function () {
      if (!this.currentCardId) return -1
      let key, card
      for (key in this.quickmailCards) {
        card = this.quickmailCards[key]
        if (this.currentCardId === card.id) {
          return Number(key)
        }
      }
      return -1
    },
    currentCardTitle: function () {
      if (!this.currentCardId) return ''
      return this.quickmailCards[this.currentCardIndex].title
    },
    currentCardPreviewJumpId: function () {
      if (!this.currentCardId) return ''
      return this.quickmailCards[this.currentCardIndex].previewJumpId
    },
    nextCardLabel: function () {
      if (this.isNextCardAvailable) {
        return this.quickmailCards[this.currentCardIndex + 1].title
      }
      return ''
    },
    prevCardLabel: function () {
      if (this.isPrevCardAvailable) {
        return this.quickmailCards[this.currentCardIndex - 1].title
      }
      return ''
    }
  },
  methods: {
    cardIdExists: function (cardId) {
      for (const key in this.quickmailCards) {
        if (this.quickmailCards[key].id === cardId) {
          return true
        }
      }
      return false
    },
    goFirstCard: function () {
      this.goCardTo(this.firstCardId)
    },
    goCurrentCard: function () {
      this.previewDialogVisible = false
      if (this.currentCardId == 'rirekisho') {
        this.$refs.editFormat.setLetterInnerHtml()
      } else if (this.currentCardId == 'letter') {
        this.$refs.editFormat.setCheckLetter()
      } else if (this.currentCardId == 'keirekisho') {
        this.$refs.editFormat.setRirekishoInnerHtml()
      } else if (this.currentCardId == 'payment') {
        this.$refs.editFormat.setKeirekishoInnerHtml()
      }
      this.$refs.editFormat.setAddressDataStaffName()
      this.$router.push({
        name: 'quickemailCard',
        params: {
          cardId: this.currentCardId
        }
      })
      this.$refs.editFormat.setPreviewScale()


      this.$refs.editFormat.$refs.previewLetterFormat.checkValid()
      this.$refs.editFormat.$refs.previewRirekishoFormat.checkValid()

      this.$eventHub.$emit('deactivate-history-item')
      this.$eventHub.$emit('card-changed', this.currentCardId)
    },
    scrollToCurrentStep: function () {
      this.$nextTick(function () {
        if (this.currentCardIndex < 0) {
          return
        }
        this.$refs.steps[this.currentCardIndex].scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'center'
        })
      })
    },
    goCardTo: function (cardId) {
      if (!this.cardIdExists(cardId)) {
        this.goFirstCard()
        return
      }
      if (cardId == 'complete') {
        return
      }
      this.currentCardId = cardId
      this.goCurrentCard()
      this.scrollToCurrentStep()
    },
    goNextCard: function () {
      if (!this.$firebase.isAuthenticated) {
        this.$eventHub.$emit('open-loginform-dialog', this.formatId, 'save')
      }
      if (this.isNextCardAvailable) {
        this.currentCardId = this.quickmailCards[this.currentCardIndex + 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    goPrevCard: function () {
      if (this.isPrevCardAvailable) {
        this.currentCardId = this.quickmailCards[this.currentCardIndex - 1].id
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    gotoBasic: function () {
      this.goCardTo('basic')
    },
    goDownloadCard: function () {
      this.goCardTo('output')
    },
    swipeNextCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goNextCard()
      }
    },
    swipePrevCard: function () {
      if (this.$deviceLib.isMobileDevice) {
        this.goPrevCard()
      }
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    paymentQuickEmailResult: function (param) {
      this.fullscreenLoading = false
      if (param == 'success') {
        this.currentCardId = 'complete'
        this.goCurrentCard()
        this.scrollToCurrentStep()
      }
    },
    loadingOn: function() {
      console.error('loadingOn')
      this.fullscreenLoading = true
    },
    paymentQuickEmail: function () {
      const app = this
      if (!this.$refs.editFormat.formatData.addressData_companyName) {
        app.$message({
          message: '수신회사명을 입력해 주세요.',
          type: 'error'
        })
        return
      } 
      if (this.$refs.editFormat.isInValidEmail ) {
        app.$message({
          message: '수신담당자 메일 주소를 올바르게 입력해 주세요.',
          type: 'error'
        })
        return
      } 
      if (!this.$refs.editFormat.isUnsameEmail) {
        app.$message({
          message: '수신담당자 메일 주소와 확인용 메일 주소가 다릅니다.',
          type: 'error'
        })
        return
      } 
      if (!this.$refs.editFormat.formatData.from_email) {
        app.$message({
          message: '발신자 메일 주소를 입력해 주세요.',
          type: 'error'
        })
        return
      } 

      const reg = new RegExp(/^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}\.[A-Za-z0-9]{1,}$/)
      if (!reg.test(this.$refs.editFormat.formatData.from_email)) {
        app.$message({
          message: '발신자 메일 주소를 올바르게 입력해 주세요.',
          type: 'error'
        })
        return
      } 

      if (!this.$refs.editFormat.formatData.from_name) {
        app.$message({
          message: '발신자 이름을입력하세요',
          type: 'error'
        })
        return
      } 
      this.fullscreenLoading = true
      this.$refs.editFormat.$refs.stripeCardElememt.submit()

    }
  },
  watch: {
    'cardId': function () {
      this.currentCardId = this.cardId
      if (this.currentCardIndex < 0) {
        this.goFirstCard()
      }
    },
    previewTabActive: function () {
      this.setPreviewScale()
    }
  },
  beforeMount: function () {
    const app = this
    if (this.cardId) {
      if (this.cardId != 'basic') {
        this.$router.push({
          name: 'quickemailCard',
          params: {
            cardId: 'basic'
          }
        })
      }
    }
  },
  beforeDestroy() {
  },
  created: function () {
    const app = this
    // console.log(this.$route.query.mynavi)
    // firebase.auth().onAuthStateChanged((user) => {
    //   if (user) {    
    //     console.log('logined')
    //   } else {
    //     this.$router.push('/login')
    //   }
    // })
  },
  mounted: function () {
    if (this.currentCardIndex < 0) {
      this.goFirstCard()
    }
    // set event listeners and timer
    window.addEventListener('popstate', this.hidePreviewDialog, false)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
    this.scrollToCurrentStep()
    this.$eventHub.$on('payment_email_result', this.paymentQuickEmailResult)
    this.$eventHub.$on('email_goto_basic', this.gotoBasic)
    this.$eventHub.$on('email_loading_on', this.loadingOn)
  },
  destroyed: function () {
    // remove event listeners and timer
    clearInterval(this.saveNotifyMessageUpdateTimer)
    this.$eventHub.$off('payment_email_result', this.paymentQuickEmailResult)
    this.$eventHub.$off('email_goto_basic', this.gotoBasic)
    this.$eventHub.$off('email_loading_on', this.loadingOn)
  }
}
</script>
